<script setup lang="ts">
import { useNotificationsStore } from '@/stores/notifications';
import Icon from './Icon.vue';

const n = useNotificationsStore();

const iconFor = (level: string) => {
  if (level === 'success') return 'check';
  if (level === 'error') return 'alert';
  if (level === 'warn') return 'alert';
  return 'info';
};

const colorFor = (level: string) => {
  if (level === 'success') return 'text-emerald-300 bg-emerald-500/10 border-emerald-500/30';
  if (level === 'error') return 'text-red-300 bg-red-500/10 border-red-500/30';
  if (level === 'warn') return 'text-amber-300 bg-amber-500/10 border-amber-500/30';
  return 'text-blue-300 bg-blue-500/10 border-blue-500/30';
};
</script>

<template>
  <Teleport to="body">
    <div class="fixed bottom-4 right-4 z-50 space-y-2 max-w-sm">
      <div
        v-for="t in n.toasts"
        :key="t.id"
        :class="[
          'anim-slide-in flex items-start gap-3 p-3 rounded-lg border backdrop-blur-md text-sm shadow-lg',
          colorFor(t.level),
        ]"
      >
        <Icon :name="iconFor(t.level)" class="w-4 h-4 mt-0.5 flex-shrink-0" />
        <div class="flex-1 break-words">{{ t.message }}</div>
        <button
          class="text-slate-400 hover:text-slate-100 transition-colors flex-shrink-0"
          @click="n.dismiss(t.id)"
          aria-label="Schließen"
        >
          <Icon name="x" class="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  </Teleport>
</template>
